import { Component, OnInit } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
declare var $: any;
import {
  faInfo,
  faFileExport,
  faChevronLeft,
  faChevronRight,
  faSitemap,
  faTimesCircle,
  faPlus,
  faRunning,
  faSearch,
  faCircle,
  faLightbulb,
  faCheckCircle,
  faThumbsUp,
  faThumbsDown,
  faBoxOpen,
  faBug,
  faInfoCircle,
  faPlusSquare,
  faEdit,
  faTrash,
  faRedo,
  faSave
} from '@fortawesome/free-solid-svg-icons';
import { Quill } from 'quill';
import { EditorChangeContent, EditorChangeSelection, Focus } from 'ngx-quill';
import { NotificationsComponent } from '../notifications/notifications.component';
import { Subscription } from 'rxjs';
import { SocketService } from '../shared/services/socket.service';
import { faJira } from '@fortawesome/free-brands-svg-icons';
import { JiraBugsListComponent } from '../jira-bugs-list/jira-bugs-list.component';
import { JiraUserService } from '../shared/services/jira-user.service';
import { ReloadToolService } from '../shared/services/reload-tool.service';
import { MainComponent } from '../main/main.component';
declare module 'quill';

@Component({
  selector: 'app-test-executor',
  templateUrl: './test-executor.component.html',
  styleUrls: ['./test-executor.component.scss'],
})
export class TestExecutorComponent implements OnInit {
  faRunning = faRunning;
  faSitemap = faSitemap;
  faInfoCircle = faInfoCircle;
  faSearch = faSearch;
  faFileExport = faFileExport;
  faTimesCircle = faTimesCircle;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faPlus = faPlus;
  faLightbulb = faLightbulb;
  faCircle = faCircle;
  faCheckCircle = faCheckCircle;
  faThumbsUp = faThumbsUp;
  faThumbsDown = faThumbsDown;
  faBoxOpen = faBoxOpen;
  faJira = faJira;
  faPlusSquare = faPlusSquare;
  faEdit = faEdit;
  faTrash = faTrash;
  faRedo = faRedo;
  faSave = faSave;
  // this.model = model;
  // // this.envMap = envMap;
  // this.AppService = AppService;
  index: any = 0;
  searchText: any = '';
  currentActivity: any = '';
  eutTypes: any = ['TF', 'UR', 'BF'];
  filterTypeCount: any = { type: 'count' };
  filterTypeList: any = { type: 'list' };
  // , 'TT'
  quillEditorContent: any = '';
  selectEnvSubstr: any = '';
  envMapArrayList: any = [];
  planNamesArray: any = [];
  tempPlanNamesArray: any = [];
  config: any;
  modelData: any;
  scopeMap: any = '';
  designTest: any = 'E';
  selectedTestAttr: any = {};
  selectedEntity: any = { eID: '' };
  selectedEntityDetails: any = {};
  build: any = '';
  selectedTest: any = '';
  selectedEUT: any = 'TF';
  newscenarioattr: any = 'Feature Behaviour';
  newscenariosymbol: any = 'Fe';
  newscenariocr: any = '+';
  newscenariopriority: any = '1';
  newscenariodesc: any = '';
  newscenariopersona: any = [];
  range: any = new Array(3);
  priority: any = ['+P1', '+P2', '+P3', '-P1', '-P2', '-P3'];
  selectedEnvironment: any = '';
  message: any = '';
  selectedTestName: any = '';
  currentEx: any = ['N', 'Y'];
  sample: any = 0;
  checklistName: any = '';
  attrDisabled: any = false;
  matchedAttribute: any = '';
  editorContentText: any = '';
  selectedEntityeID: any = '';
  selectedString: any = [];
  selectedEditorAttribute = { symbol: 'Mi', name: 'Migration', level: 'L8' };
  matchedScenario: any = '';
  selectedPlanName: any = '';
  selectedEntityNotes: any = {};

  // tasks = this.model.tasks;
  plannerName: any = '';
  testTypes: any = [
    {
      name: 'Feature Behaviour',
      symbol: 'Fe',
      eType: 'TF',
      level: 'L5',
    },
    {
      name: 'Requirement Behaviour',
      symbol: 'Rb',
      eType: 'UR',
      level: 'L5',
    },
    {
      name: 'Flow Behaviour',
      symbol: 'Fb',
      eType: 'BF',
      level: 'L5',
    },
  ];
  attributeSelected: any = [];
  levelSelected: any = [];
  selectedDeleteScenEid: any = '';
  personaSelected: any = [];
  crSelected: any = [];
  editorContent: any = '';
  entityName: any = '';
  editScenario: any = { scenID: '' };
  errorMessage = '';
  duplicateScenario = '';
  newscenariolevel: any = '';
  selectedEditorLevel: any = 'L8';
  scenarioTypes = ['+', '-'];
  mappedAttribute: any = '';
  currentView: any = 'scenarios';
  selectedModule: any = {};
  scenarioStatusTestTypes: any = [];
  entityBC: any;
  entityAC: any;
  entityOC: any;
  entityPI: any;
  clickEventsubscription: Subscription;
  clickEventsubscriptionSocket: Subscription;
  toastMsg: any = '';
  jiraBugDetails: any = {
    project: { key: "" }, summary: "Sample text", description: "Sample desc", issuetype: { name: "Bug" }
  };
  loginDetails: any;
  smartChecklist: boolean = true;
  syncModelDataObject: any;
  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private socketService: SocketService,
    private Config: Config,
    public mainComponent: MainComponent,
    private AppService: AppService,
    private reloadToolService: ReloadToolService,
    public notificationsComponent: NotificationsComponent,
    public jiraBugsListComponent: JiraBugsListComponent,
    private JiraUserService: JiraUserService
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });

    this.clickEventsubscription = this._sharedService
      .getClickEvent()
      .subscribe((eut) => {
        this.activate(eut);
      });
  }

  ngOnInit(): void {
    $(() => {
      $('[data-toggle="popover"]').popover();
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.changeCurrentView('scenarios');
    this.loginDetails = JSON.parse(
      localStorage.getItem('loginDetails') || '{}'
    );
    setTimeout(() => {
      this.getVideoURL('Ex');
    }, 2000);
    this.config = this.Config;
    this.modelData = this._sharedService.loadedProjectData.model;
    this.selectedModule = this.modelData.modules[0];
    this.envMapListGenerate();
    this.quillNoteReload();
    setInterval(() => {
      this.updateProjectData();
    }, 2000);
    // this.scopeMap = this.modelData.scopeMap;
    this.selectTest(this.testTypes[0]);
    this.reloadToolService.triggerSmartChecklist('');
    window.localStorage.removeItem("entityTestName");
  }

  // onReloadInit(scopeMap) {
  //   this.scopeMap = scopeMap;
  //   this.designTest = 'E';
  //   // this.selectEut(this.selectedEUT);

  //   if (this.selectedEntity) {
  //     this.matchedEntity = this.model.listOfEUTs.find(eut => eut.eID == this.selectedEntity.eID);
  //     if (this.matchedEntity) {
  //       this.loadEntityDetails(this.selectedEntity);
  //       // if (this.selectedTestAttr) {
  //         // this.matchedEntity = this.model.listOfAttributes.find(attr => attr.symbol == this.selectedTestAttr.symbol);
  //         // if (this.matchedEntity) {
  //         //   this.selectTest(this.selectedTestAttr);
  //           if (this.selectedEnvironment) {
  //             let envFound = this.model.envMapArrayList.find(env => env.name == this.selectedEnvironment);
  //             if (envFound) {
  //               this.chooseEnvironment(this.selectedEnvironment);
  //               this.selectBuild(this.build);
  //             } else {
  //               this.selectedEnvironment = '';
  //               this.build = '';
  //             }
  //           }
  //         // } else {
  //         //   this.newscenarioattr = '';
  //         //   this.newscenariosymbol = '';
  //         //   // this.selectedTestAttr = '';
  //         //   this.selectedEnvironment = '';
  //         // }
  //       // }

  //     } else {
  //       this.entityName = '';
  //       this.selectedEntity = '';
  //       // this.newscenarioattr = '';
  //       this.newscenariosymbol = '';
  //       // this.selectedTestAttr = '';
  //       this.selectedEnvironment = '';
  //       $('#validaotrScenTextarea').val('');
  //     }
  //   } else {
  //     this.entityName = '';
  //     this.selectedEntity = '';
  //     // this.newscenarioattr = '';
  //     this.newscenariosymbol = '';
  //     // this.selectedTestAttr = '';
  //     this.selectedEnvironment = '';
  //     $('#validaotrScenTextarea').val('');
  //   }
  // }
  updateProjectData() {
    this._sharedService.projectContent(this.modelData);
  }
  openChatGPTassist() {
    this.mainComponent.openChatGPT();
    window.localStorage.setItem("assistantTool", "ET-DE");
    if (this.selectedEntity.eName) {
      window.localStorage.setItem("entityTestName", this.selectedEntity.eName);
    }
    // setTimeout(() => {
    //   if (this.choosenEUT) {
    //     this.loadEntityDetails(this.choosenEUT);
    //   }
    // }, 500);
  }
  updateTestTypeStatus() {
    if (this.selectedEntity) {
      var foundEntityDetails = this.modelData.EUTdetails.find((entity: any) => entity.eID == this.selectedEntity.eID)

      this.scenarioStatusTestTypes = [];
      this.scenarioStatusTestTypes = this.testTypes.concat(this.config.listOfAttributesUpdated);

      for (var i = 0; i < this.scenarioStatusTestTypes.length; i++) {


        if (foundEntityDetails.testTypes) {

          var fountTestType = foundEntityDetails.testTypes.find((test: any) => this.scenarioStatusTestTypes[i].symbol == test.symbol)
          if (fountTestType) {
            this.scenarioStatusTestTypes[i]['satisfy'] = true;
          } else {
            this.scenarioStatusTestTypes[i]['satisfy'] = false;
          }
        } else {
          this.scenarioStatusTestTypes[i]['satisfy'] = false;
        }

        if (this.scenarioStatusTestTypes[i].symbol == "Fe" || this.scenarioStatusTestTypes[i].symbol == "Rb" || this.scenarioStatusTestTypes[i].symbol == "Fb") {
          this.scenarioStatusTestTypes[i]['satisfy'] = true;
        }
        var foundScenario = this.modelData.scenarios.find((scenario: any) => scenario.attribute.symbol == this.scenarioStatusTestTypes[i].symbol && scenario.eID == this.selectedEntity.eID)
        if (foundScenario) {
          this.scenarioStatusTestTypes[i]['stated'] = true;
        } else {
          this.scenarioStatusTestTypes[i]['stated'] = false;
        }
      }
    }
  }
  editorChanged(event: EditorChangeContent | EditorChangeSelection) {
    this.editorContent = event['editor']['root']['innerHTML'];
    this.editorContentText = event['editor']['root']['innerText'];
    // console.log("Changed", this.editorContent);
    if (event['event'] == 'selection-change') {
      var range: any = event['range'];
      this.selectedString = '';
      var text = event.editor.getText(range['index'], range['length']);
      // console.log("text",text);
      // console.log('text1', this.editorContentText);
      // console.log('index', this.editorContentText.replace(/\r?\n|\r/, ''));
      // var newText = this.editorContentText.replace(/\s+/g, '');
      // console.log('tt', newText.substr(range['index'], range['length']));
      this.selectedString = text.split('\n');
      // this.selectedString = cleanArray.filter(function (el: any) {
      //   return el != null;
      // });
      this.selectedString = this.selectedString.filter((item: any) => item);
      // console.log('text', this.selectedString);
    } else {
      // let project = {
      //   projectID: window.localStorage.getItem('projectID'),
      //   userID: window.localStorage.getItem('userID'),
      //   content: this.editorContent,
      // };
      // this.ProjectServices.addDesignerContent(project).subscribe(
      //   (response: any) => {
      //     // console.log('res', response);
      //     if (response.statusCode == 200) {
      //       // this.quillEditorContent = response.record.content;
      //     } else {
      //     }
      //   }
      // );
    }
  }
  blur(event: Focus) {
    var foundNotes = false;
    let notesObject;
    if (this.selectedEntity.eID) {
      if (this.modelData.myNotes.length > 0) {
        for (var i = 0; i < this.modelData.myNotes.length; i++) {
          if (this.modelData.myNotes[i].eID == this.selectedEntity.eID) {
            this.modelData.myNotes[i]['notes'] = this.editorContent;
            foundNotes = true;
            this.syncModelDataObject = {
              "type": "NOTES",
              "operation": "UPDATE",
              "data": this.selectedEntity,
              "notes": this.editorContent
            }
            this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
          }
        }
        if (foundNotes == false) {
          notesObject = {
            "eID": this.selectedEntity.eID,
            "notes": this.editorContent
          }
        }
      } else {
        notesObject = {
          "eID": this.selectedEntity.eID,
          "notes": this.editorContent
        }
      }
      if (notesObject != null) {
        this.modelData.myNotes.push(notesObject);
        this.syncModelDataObject = {
          "type": "NOTES",
          "operation": "CREATE",
          "data": notesObject
        }
        this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      }
      // console.log(this.modelData.myNotes);
    }
  }
  quillNoteReload() {
    let project = { projectId: window.localStorage.getItem('projectID') };
    this.ProjectServices.getDesignerContent(project).subscribe(
      (response: any) => {
        // console.log('res', response);
        if (response.statusCode == 200) {
          if (response.record) {
            // this.quillEditorContent = response.record.content;
            // this.quill.root.innerHTML = response.record.content;
            // getEditorContentData = response.record.content;
          }
        } else {
        }
      }
    );
  }
  openSmartChecklist() {
    this.reloadToolService.triggerSmartChecklist('la');
    if (this.smartChecklist == false) {
      $(".autoCursor").addClass('checklistIcon');
      this.smartChecklist = true;
    } else {
      $(".autoCursor").removeClass('checklistIcon');
      this.smartChecklist = false;
    }
  }
  selectedAttribute(attr: any) {
    this.selectedEditorAttribute = attr;
    this.selectedTest = attr;
  }

  checkQuillSelection() {
    // console.log('Attr', this.selectedTest);
    // console.log('List', this.selectedString);
    // console.log('EUT', this.selectedEntity);
    // console.log('Scenarios', this.modelData.scenarios);
    if (this.selectedEntity.eID) {
      for (var i = 0; i < this.selectedString.length; i++) {
        this.matchedScenario = this.modelData.scenarios.find(
          (scen: any) =>
            scen.attribute.symbol == this.selectedTest.symbol &&
            scen.description == this.selectedString[i] &&
            scen.eID == this.selectedEntity.eID
        );
        // console.log("this.matchedScenario", this.matchedScenario);
        if (!this.matchedScenario) {
          // if (this.selectedString[i]) {
          this.add(
            this.selectedString[i],
            this.selectedEntity.eID,
            this.selectedTest,
            '-1',
            'E',
            '+',
            '1',
            this.build,
            this.selectedEnvironment
          );
          // }
        } else {
          // console.log("this.matchedScenario", this.matchedScenario);
          this.errorMessage = this.AppService.getResourceText("V033");
          this.duplicateScenario = "'" + this.matchedScenario.description + "'";
          $("#duplicateScenarioErrorPopupModelDesigner").modal("show");
        }
      }
    } else {
    }
  }
  // new code open

  loadScenarioDetails(scenarioChoosen: any) {
    this.selectedTestName = '';
    this.checklistName = scenarioChoosen.checklist;
    this.matchedAttribute = this.config.listOfAttributesUpdated.find(
      (att: any) => att.symbol == scenarioChoosen.tID
    );
    if (this.matchedAttribute) {
      this.selectTest(this.matchedAttribute);
      this.attrDisabled = true;
    }
  }
  //function to change the tab active views
  changeCurrentView(view: any) {
    $(() => {
      $('[data-toggle="popover"]').popover();
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.currentView = view;
  }

  createActivity(appname: any) {
    // console.log('appname', appname);
    this.currentActivity = appname;
    if (
      appname != 'Db' &&
      appname != 'Lo' &&
      appname != 'Nt' &&
      appname != 'Snt' &&
      appname != 'No' &&
      appname != 'XX' &&
      appname != 'Tdsp' &&
      appname != 'Tdsc' &&
      appname != 'Tdde' &&
      appname != 'Exsc' &&
      appname != 'Exde' &&
      appname != 'Exsp'
    ) {
      this.getVideoURL(appname);
    }
    var sessionID = localStorage.getItem('sessionID');
    var projectID = localStorage.getItem('projectID');
    var userID = localStorage.getItem('userID');
    if (sessionID == null) {
      sessionID = '';
    }
    let activityData = {
      appname: appname,
      sessionid: sessionID,
      projectid: projectID,
      userid: userID,
    };

    this.AppService.updateActivity(activityData).subscribe((response: any) => {
      // console.log('updateActivity response', response);
      if (response.statusCode === 200) {
        if (response.sessionid != undefined) {
          localStorage.setItem('sessionID', response.sessionid);
          this.notificationsComponent.getNotifications();
        }
        if (localStorage.getItem('sessionID') != undefined && appname == 'No') {
          this.notificationsComponent.getNotifications();
        }
      }
    });
  }

  // new code close
  //choosing priority for a scenario and setting the type of the scenario(+ve or -ve)
  //Setting the priority and type of the scenario based on what it starts and ends with.
  setPriority(priority: any) {
    this.newscenariocr = priority.charAt(0);
    this.newscenariopriority = priority.substr(priority.length - 1);
  }
  //function to select the design type for scenarios
  //if T is chosen ->its only for a test, therefore entitydropdown will be disabled
  //if E is chosen-> its for an entity with a test type
  selectDesignType(type: any) {
    this.designTest = type;
    this.selectedEntity = { eID: '' };
    this.selectedEntityDetails = {};
    this.entityBC = '';
    this.entityOC = '';
    this.entityPI = '';
    this.entityAC = '';
    this.entityName = '';
    this.selectedTest = '';
    this.build = '';
    this.selectedEnvironment = '';
    this.selectedTestName = '';
  }

  //changing the entity type by toggling the span button
  //reset the entity name and details populated in the form
  changeEntity() {
    this.index = (this.index + 1) % this.eutTypes.length;
    this.selectedEntity = { eID: '' };
    this.selectedEntityDetails = {};
    this.entityBC = '';
    this.entityOC = '';
    this.entityPI = '';
    this.entityAC = '';
    this.entityName = '';
    this.selectedTest = '';
    this.selectedTestName = '';
    this.attrDisabled = false;
  }

  //note:
  //for now we just have three hard coded build numbers 1,2,3
  //which will have to be set previously elsewhere
  //this function is to set the build number and query the
  // run info for a scenario as the key for a run would be the scenid with the build
  selectBuild(num: any) {
    this.build = num;
  }

  chooseEnvironment(name: any) {
    this.selectedEnvironment = name;
  }
  activate(entity: any) {
    // console.log("entity", entity);
    if (entity.toolType == 'ex') {

      if (this.modelData.EUTdetails) {
        this.loadEntityDetails(entity);
        this.selectTest(entity.testType);

        this.chooseEnvironment(entity.envName);
        this.selectedModule = this.modelData.modules.find(
          (mod: any) => mod.mID == entity.mID
        );
        // this.attributeSelected = [];
        // this.addToAttributeFilter(entity.testType.symbol,true);
      } else {
        setTimeout(() => {
          this.loadEntityDetails(entity);
          this.selectTest(entity.testType);
          this.chooseEnvironment(entity.envName);
          this.selectedModule = this.modelData.modules.find(
            (mod: any) => mod.mID == entity.mID
          );
        }, 5000);
      }
      // this.loadEntityDetails(entity);
      // this.index = this.eutTypes.findIndex((type: any) => type == entity.eType);

      // this.selectTest(entity.testType);
      this.attributeSelected = [];
      this.addToAttributeFilter(entity.testType.symbol, true);
    }
  }
  //handler to get the required details based on the selected entity
  loadEntityDetails(eutChosen: any) {
    // console.log('eutChosen', eutChosen);
    // console.log('this.modelData', this.modelData);
    this.entityName = eutChosen.eName;
    this.selectedEUT = eutChosen.eType;
    this.selectedEntity = eutChosen;
    this.selectedEntityeID = eutChosen.eID;
    window.localStorage.setItem('entityTestID', eutChosen.eID);
    if (this.selectedEntity) {
      this.selectedEntityDetails = this.modelData.EUTdetails.find(
        (eut: any) => eut.eID == eutChosen.eID
      );
    }
    // console.log('this.entityName', this.entityName);
    if (!this.selectedEntityDetails) {
      this.addEUTDetails(eutChosen);
    } else {
    }
    this.selectedEntityNotes = this.modelData.myNotes.find(
      (eut: any) => eut.eID == eutChosen.eID
    );
    if (this.selectedEntityNotes) {
      this.quillEditorContent = this.selectedEntityNotes.notes;
    } else {
      this.quillEditorContent = '';
    }
    this.entityBC = this.selectedEntityDetails.bc;
    this.entityAC = this.selectedEntityDetails.ac;
    this.entityOC = this.selectedEntityDetails.outcomes;
    this.entityPI = this.selectedEntityDetails.pIssues;
    if (eutChosen.eType == 'TF') {
      this.selectedTest = this.getDefaultTestTypeByEUTtype(eutChosen.eType);
      this.selectedTestName = 'Feature Behaviour';
    } else if (eutChosen.eType == 'UR') {
      this.selectedTest = this.getDefaultTestTypeByEUTtype(eutChosen.eType);
      this.selectedTestName = 'Requirement Behaviour';
    } else if (eutChosen.eType == 'BF') {
      this.selectedTest = this.getDefaultTestTypeByEUTtype(eutChosen.eType);
      this.selectedTestName = 'Flow Behaviour';
    }
  }

  updateEntityDetails() {
    // alert("new");
    for (var i = 0; i < this.modelData.EUTdetails.length; i++) {
      if (this.modelData.EUTdetails[i].eID == this.selectedEntity.eID) {
        this.modelData.EUTdetails[i]['bc'] = this.selectedEntityDetails.bc;
        this.modelData.EUTdetails[i]['ac'] = this.selectedEntityDetails.ac;
        this.modelData.EUTdetails[i]['outcomes'] = this.selectedEntityDetails.outcomes;
        this.modelData.EUTdetails[i]['pIssues'] = this.selectedEntityDetails.pIssues;
        this.syncModelDataObject = {
          "type": "SPECS",
          "operation": "UPDATE",
          "data": this.modelData.EUTdetails[i]
        }
        this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      }
    }

  }
  getDefaultTestTypeByEUTtype(type: any) {
    var testType = this.testTypes.find(
      (test: any) => test.eType == type
    );
    return testType;
  }
  addEUTDetails(eutChosen: any) {
    this.modelData.EUTdetails.push({
      eID: eutChosen.eID,
      bc: '',
      ac: '',
      outcomes: '',
      bDescription: '',
      pIssues: '',
      notes: this.config.entityDefaultNotes
    });
    if (this.selectedEntity) {
      this.selectedEntityDetails = this.modelData.EUTdetails.find(
        (eut: any) => eut.eID == eutChosen.eID
      );
    }
  }
  editScenarioData(scenario: any) {
    this.editScenario = scenario;
    this.newscenariodesc = scenario.description;
    this.newscenariopersona = scenario.persona;
    let matchedItem = this.config.listOfAttributesUpdated.find(
      (att: any) => att.symbol == scenario.tID
    );
    if (!matchedItem) {
      matchedItem = this.testTypes.find(
        (att: any) => att.symbol == scenario.tID
      );
    }
    if (matchedItem) {
      // console.log(matchedItem);
      this.newscenariosymbol = matchedItem.symbol;
      this.newscenarioattr = matchedItem.name;
      this.selectedTest = matchedItem;
      this.newscenariolevel = matchedItem.level;
    }
    this.newscenariopriority = scenario.priority;
    this.newscenariocr = scenario.cr;
    // this.newscenariopersona = scenario.persona;
  }

  CreateScenario(desc: any) {
    var scenaDesc = desc.trim();
    // console.log(this.selectedTest);
    // console.log(this.newscenariosymbol);
    // console.log(scenaDesc);
    // console.log(this.newscenariocr);
    // console.log(this.newscenariopriority);
    // console.log(this.newscenariopersona);
    // console.log('edit', this.editScenario);
    if (this.editScenario.scenID != '') {
      if (scenaDesc.length > 0) {
        // console.log('Duplicate');
        for (var i = 0; i < this.modelData.scenarios.length; i++) {
          if (
            this.modelData.scenarios[i].description.toLowerCase() ==
            scenaDesc.toLowerCase() &&
            this.modelData.scenarios[i].tID == this.selectedTest.symbol &&
            this.selectedEntity.eID == this.modelData.scenarios[i].eID
          ) {
            if (
              this.modelData.scenarios[i].scenID != this.editScenario.scenID
            ) {
              this.errorMessage = "Scenario already exists";
              this.duplicateScenario = "'" + scenaDesc + "'";
              $('#duplicateScenarioErrorPopupModelExecutor').modal('show');
              $('#validaotrScenTextarea').val(scenaDesc);
              return;
            }
          }
        }
      }
    } else {
      for (var i = 0; i < this.modelData.scenarios.length; i++) {
        if (
          this.modelData.scenarios[i].description.toLowerCase() ==
          scenaDesc.toLowerCase() &&
          this.modelData.scenarios[i].tID == this.selectedTest.symbol &&
          this.selectedEntity.eID == this.modelData.scenarios[i].eID
        ) {
          this.errorMessage = this.AppService.getResourceText('V033');
          this.duplicateScenario = "'" + scenaDesc + "'";
          $('#duplicateScenarioErrorPopupModelExecutor').modal('show');
          $('#validaotrScenTextarea').val(scenaDesc);
          return;
        }
      }
    }
    // console.log('loop crossed');
    // console.log('scenID', this.editScenario.scenID);
    if (this.editScenario.scenID != '') {
      // console.log('scenaDesc', scenaDesc);
      if (scenaDesc.length > 0) {
        this.updateScenario(
          this.editScenario.scenID,
          this.selectedTest,
          this.newscenariocr,
          this.newscenariopriority,
          scenaDesc
        );
        this.scenarioAddReset();
      } else {
        $('#emptyScenAddErrorPopupValidator').modal('show');
        return;
      }
    } else {
      var scenarioDesc = scenaDesc.trim();
      if (this.selectedEntity.eID == "" || this.selectedEntity.eID == undefined) {
        this.newscenariodesc = '';
        $('#emptyScenAddErrorPopupValidator').modal('show');
        $('#validaotrScenTextarea').val('');
        return;
      }
      if (scenarioDesc != '') {
        this.add(
          scenarioDesc,
          this.selectedEntity.eID,
          this.selectedTest,
          '-1',
          'E',
          this.newscenariocr,
          this.newscenariopriority,
          this.build,
          this.selectedEnvironment
        );
        this.scenarioAddReset();
        $('#validatorScenTable tr').removeClass('active');
      } else {
        this.newscenariodesc = '';
        $('#emptyScenAddErrorPopupValidator').modal('show');
        $('#validaotrScenTextarea').val('');
      }
    }
  }
  deleteScenarioModal(scenaDesc: any) {
    // console.log("scenaDesc", scenaDesc);
    if (scenaDesc.length > 0) {
      this.message = 'Would you like to delete?';
      $('#deleteScenarioConfirmPopupModelValidator').modal('show');
    } else {
      this.newscenariodesc = '';
      $('#emptyScenAddErrorPopupValidator').modal('show');
      $('#validaotrScenTextarea').val('');
    }

  }
  scenarioAddReset() {
    this.newscenarioattr = 'Feature Behaviour';
    this.newscenariosymbol = 'Fe';
    this.newscenariocr = '+';
    this.newscenariopriority = '1';
    this.newscenariodesc = '';
    this.newscenariopersona = [];
    this.editScenario = { scenID: '' };
    $('#validaotrScenTextarea').val('');
  }
  deleteScenarioByEdit() {
    // console.log("secn", this.editScenario);
    if (this.editScenario) {
      this.delete(this.editScenario.scenID);
      this.newscenariodesc = '';
      this.scenarioAddReset();
      $('#deleteScenarioConfirmPopupModelValidator').modal('hide');
    }
  }
  //adding a new scenario by pressing enter
  //this will also make a record in the run info for the particular scenario
  // add(newScenario: any, id: any) {
  //   this.add(newScenario, this.selectedEntity.eID, this.selectedTest, id, this.designTest, this.build, this.selectedEnvironment);
  // }

  //deleting ascenario by backspace
  //this will also remove the record in the run info for the particular scenario

  //Function to clear th empty list
  onFocusOut(model: any, id: any) {
    if (!model) {
      this.delete(id);
    }
  }
  //selecting the test type for a scenario
  // selectTest(test: any) {
  //   this.newscenarioattr = test.name;
  //   this.newscenariosymbol = test.symbol;
  //   this.selectedTestAttr = test;
  //   console.log('this.selectedTest', this.selectedTest);
  //   console.log('this.selectedTestName', this.selectedTestName);
  // }
  selectModule(test: any) {
    this.selectedModule = test;
    this.selectedEntity = { eID: '' };
    this.entityName = '';
    this.selectedTest = '';
    this.selectedTestName = '';
    this.entityBC = '';
    this.entityOC = '';
    this.entityPI = '';
    this.entityAC = '';
    this.quillEditorContent = '';
    // this.index = this.eutTypes.findIndex((type: any) => type == test);
    if (test == 'TT') {
      this.designTest = 'T';
    } else {
      this.designTest = 'E';
    }
    this.checklistName = '';
    this.attrDisabled = false;
  }
  getVideoURL(urlName: any) {
    var videoURL = this.AppService.getVideoURL(urlName);
    var element: any = document.getElementById(urlName + 'VideoLink') || {};
    element.src = videoURL;
  }
  //to add a link to the person for a particular scenario
  //if checked we add to the persona list of scenario
  //if unchecked we remove from the list
  mapScenarioToPerson(persona: any, isChecked: any) {
    if (isChecked) {
      var index = this.newscenariopersona.findIndex(
        (person: any) => person == persona
      );
      if (index == -1) {
        this.newscenariopersona.push(persona);
      }
    } else {
      var index = this.newscenariopersona.findIndex(
        (person: any) => person == persona
      );
      if (index > -1) {
        this.newscenariopersona.splice(index, 1);
      }
    }
    // console.log(this.newscenariopersona);
  }

  //update the run status for a particular scenario
  updateStatus(scenarioID: any, status: any) {

    for (var i = 0; i < this.modelData.runInfo.length; i++) {
      if (
        this.modelData.runInfo[i].scenID == scenarioID &&
        this.modelData.runInfo[i].buildID == this.build
      ) {
        this.modelData.runInfo[i].status = status;
        this.syncModelDataObject = {
          "type": "RUNINFO",
          "operation": "UPDATE",
          "data": { status: status, scenID: scenarioID, buildID: this.build }
        }
        this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
        return status;
      }
      // console.log("length",this.modelData.runInfo.length,i);
      // if(this.modelData.runInfo.length == i+1){
      //   console.log("same");
      //   this.addRun(scenarioID, this.build, status, this.selectedEnvironment);
      //   return 'N';
      // }
    }
    // var runData = this.modelData.runInfo.find(
    //   (aRun: any) => aRun.scenID == scenarioID && aRun.buildID == this.build
    // );
    // console.log('runData', runData);
    // console.log('status', status);
    // if (runData) {
    //   runData.status = status;
    // } else {
    //   this.addRun(scenarioID, this.build, status, this.selectedEnvironment);
    // }
  }

  //getting the run status for a particular scenario
  getStatus(scenarioID: any) {
    // console.log('scenarioID', scenarioID);
    // console.log('runInfo', this.modelData.runInfo);
    if (this.build) {
      var runData = this.modelData.runInfo.find(
        (aRun: any) => aRun.scenID == scenarioID && aRun.buildID == this.build
      );
      // console.log('runData', runData);
      if (runData) {
        if (runData.status == '') {
          return 'N';
        } else {
          return runData.status;
        }
      } else {
        this.addRun(scenarioID, this.build, status, this.selectedEnvironment);
        return 'N';
      }
    }
    return status;
  }
  envMapListGenerate() {
    this.selectEnvSubstr = '';
    this.envMapArrayList = [];
    for (var i = 0; i < this.modelData.envMap.length; i++) {
      for (var j = 0; j < this.modelData.envMap[i].envList.length; j++) {
        // var obj: any = {};
        var envSubstr = this.modelData.envMap[i].envName.substring(0, 2);
        var envCode = envSubstr.toUpperCase();
        let envname =
          envCode +
          '1.' +
          (j + 1) +
          '(' +
          this.modelData.envMap[i].envList[j] +
          ')';
        // obj['name'] = envname;
        // obj['value'] = this.modelData.envMap[i].envList[j];
        let obj: any = {
          name: envname,
          value: this.modelData.envMap[i].envList[j],
        };
        this.envMapArrayList.push(obj);
      }
    }
  }
  updateScenario(
    scenID: any,
    attr: any,
    cr: any,
    pri: any,
    // persona: any,
    desc: any
  ) {
    for (var i = 0; i < this.modelData.scenarios.length; i++) {
      if (this.modelData.scenarios[i].scenID == scenID) {
        this.modelData.scenarios[i].attribute = attr;
        this.modelData.scenarios[i].tID = attr.symbol;
        this.modelData.scenarios[i].cr = cr;
        this.modelData.scenarios[i].priority = pri;
        // this.modelData.scenarios[i].persona = persona;
        this.modelData.scenarios[i].description = desc;
        this.syncModelDataObject = {
          "type": "SCENARIO",
          "operation": "UPDATE",
          "data": this.modelData.scenarios[i]
        }
        this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      }
    }
  }
  add(
    newScenario: any,
    eID: any,
    attribute: any,
    id: any,
    sType: any,
    cr: any,
    priority: any,
    buildNo: any,
    envName: any
  ) {
    // console.log("newScenario", newScenario);
    var scenario = {
      EorT: sType,
      scenID: this.uniqueSCID(),
      description: newScenario,
      eID: eID,
      attribute: attribute,
      tID: attribute.symbol,
      priority: priority || '1',
      cr: cr || '+',
    };
    // for (var i = 0; i < this.modelData.listOfEUTs.length; i++) {
    //   if (this.modelData.listOfEUTs[i].eID == eID) {
    //     this.modelData.listOfEUTs[i].scenarioCount++;
    //   }
    // }
    var newID = id + 1;
    // console.log("scenario", scenario);
    this.modelData.scenarios.unshift(scenario);
    this.syncModelDataObject = {
      "type": "SCENARIO",
      "operation": "CREATE",
      "data": scenario
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // this.scenarios.splice(newID, 0, scenario);

    this.addRun(scenario.scenID, buildNo, 'N', envName);
    this.selectedString = '';
    this.selectedEditorAttribute = { symbol: 'Mi', name: 'Migration', level: 'L8' };
  }
  addRun(scenID: any, build: any, status: any, env: any) {
    var aRun = {
      scenID: scenID,
      buildID: build,
      status: status,
      outcome: 'P',
      // timeStamp: Date.now(),
      timeStamp: new Date(),
      environment: env,
    };
    this.modelData.runInfo.push(aRun);
    this.syncModelDataObject = {
      "type": "RUNINFO",
      "operation": "CREATE",
      "data": aRun
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // console.log(this.modelData);
  }

  delete(scenID: any) {
    // console.log('sc', scenID);
    // if (id >= 0) {
    // console.log("scen", this.scenarios[id]);
    for (var i = 0; i < this.modelData.scenarios.length; i++) {
      if (scenID == this.modelData.scenarios[i].scenID) {
        // console.log("sc1",this.scenarios[i]);
        this.selectedDeleteScenEid = this.modelData.scenarios[i].eID;
        this.modelData.scenarios.splice(i, 1);
        this.syncModelDataObject = {
          "type": "SCENARIO",
          "operation": "DELETE",
          "data": { scenID: scenID }
        }
        this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      }
    }
    // console.log("scccc",this.scenarios);
    this.deleteScenarioByID(scenID);
    for (var j = 0; j < this.modelData.listOfEUTs.length; j++) {
      if (this.modelData.listOfEUTs[j].eID == this.selectedDeleteScenEid) {
        this.modelData.listOfEUTs[j].scenarioCount--;
      }
    }
    //   return this.scenarios.splice(id, 1);
    // }
  }
  deleteScenarioByID(scenID: any) {
    // console.log("scen", scenario.scenID);
    if (scenID) {
      for (var i = 0; i < this.modelData.runInfo.length; i++) {
        if (scenID == this.modelData.runInfo[i].scenID) {
          this.modelData.runInfo.splice(i, 1);
          i--;
        }
      }
      for (var j = 0; j < this.modelData.suites.length; j++) {
        for (var k = 0; k < this.modelData.suites[j].scenarios.length; k++) {
          if (scenID == this.modelData.suites[j].scenarios[k]) {
            this.modelData.suites[j].scenarios.splice(k, 1);
            break;
          }
        }
      }
    }
  }
  selectTest(test: any) {
    // console.log("test", test);
    this.newscenariosymbol = test.symbol;
    this.selectedTest = test;
    this.selectedTestName = test.name;
    var symbol = test.symbol;
    this.newscenariolevel = test.level;
    if (symbol == 'Rb' || symbol == 'Fb') {
      this.newscenariolevel = 'L5';
    } else if (symbol == 'Fe') {
      this.newscenariolevel = 'L4';
    }
    this.selectedTest['level'] = this.newscenariolevel;
  }

  selectLevel(level: any) {
    this.newscenariolevel = level;
    if (level != 'L4' && level != 'L5') {
      this.selectedTest = this.config.listOfAttributesUpdated.find(
        (attr: any) => attr.level == level
      );
    } else {
      this.selectedTest = this.config.listofFunctionalityTestTypes.find(
        (attr: any) => attr.level == level
      );
    }

  }
  //function to get scenario count by eutID
  getScenarioCountByeutID(eut: any) {
    var count = 0;
    for (var i = 0; i < this.modelData.scenarios.length; i++) {
      if (this.modelData.scenarios[i].eID == eut.eID) {
        count++;
      }
    }
    return count;
  }
  selectType(type: any) {
    this.newscenariocr = type;
  }

  //generation of unique id for an scenario
  uniqueSCID() {
    var model = this;
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      'SC' +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  }
  //getting the run outcome for a particular scenario
  getOutcome(scenarioID: any) {
    var runData = this.modelData.runInfo.find(
      (aRun: any) => aRun.scenID == scenarioID && aRun.buildID == this.build
    );
    if (runData) {
      return runData.outcome;
    }
  }

  //update the run outcome for a particular scenario
  updateOutcome(scenarioID: any, outcome: any) {
    var runData = this.modelData.runInfo.find(
      (aRun: any) => aRun.scenID == scenarioID && aRun.buildID == this.build
    );
    if (runData) {
      runData.outcome = outcome;
      this.syncModelDataObject = {
        "type": "RUNINFO",
        "operation": "UPDATEO",
        "data": { outcome: outcome, scenID: scenarioID, buildID: this.build }
      }
      this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    }
  }

  checkAttributeMap(attribute: any) {
    // console.log("attr",attribute);
    // console.log("this.selectedEntity",this.selectedEntity);
    // console.log("this.scopeMap",this.scopeMap);
    // if (this.selectedEntity) {
    //   this.mappedAttribute = this.scopeMap.find((scope: any) => scope.aType == attribute.symbol && scope.eID == this.selectedEntity.eID);
    //   if (this.mappedAttribute) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }else{
    //   return false;
    // }
  }

  scenarioExist() {
    var controller = this;
    // if (controller.selectedEntity) {
    //   if (controller.designTest == 'E' && controller.selectedEntity.eID != undefined) {
    //     var scenarios = this.model.scenarios.filter(scenario => scenario.EorT == controller.designTest && scenario.eID == controller.selectedEntity.eID && scenario.tID == controller.selectedTest);
    //     if (scenarios.length <= 0) {
    //       return true;
    //     }
    //   }
    // } else if (controller.designTest == 'T' && controller.selectedTest != "") {
    //   var scenarios = this.model.scenarios.filter(scenario => scenario.EorT == controller.designTest && scenario.eID == undefined && scenario.tID == controller.selectedTest);
    //   if (scenarios.length <= 0) {
    //     return true;
    //   }
    // } else {
    //   return false;
    // }
    return false;
  }

  showScenario(scenario: any) {
    var controller = this;
    if (controller.selectedEntity) {
      if (scenario.EorT == 'E') {
        if (
          scenario.EorT == controller.designTest &&
          scenario.eID == controller.selectedEntity.eID
        ) {
          return true;
        }
      } else if (scenario.EorT == 'T') {
        if (
          scenario.EorT == controller.designTest &&
          scenario.eID == undefined
        ) {
          return true;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
    return false;
  }

  entityExists() {
    var entities = this.modelData.listOfEUTs.filter(
      (entity: any) => entity.mID == this.selectedModule.mID
    );
    if (entities.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  getEntityType(eType: any) {
    if (eType == 'TF') {
      return 'Features';
    } else if (eType == 'UR') {
      return 'Requirements';
    } else if (eType == 'BF') {
      return 'Flows';
    }
    return 'Features';
  }
  generateReport(auto: any) {
    let mapperArray = ['Designer'];
    window.localStorage.setItem('exportedData', JSON.stringify(mapperArray));
    window.localStorage.setItem(
      'scenarioEntity',
      JSON.stringify(['TF', 'UR', 'BF', 'XX'])
    );
    if (auto == 'true') {
      window.open('/exportReport', '_blank');
      window.localStorage.setItem('autoDownload', 'true');
    }
  }

  loadPlanNamesList() {
    var tasks = this.modelData.tasks;
    this.planNamesArray = [];
    this.tempPlanNamesArray = [];
    for (var t = 0; t < tasks.length; t++) {
      if (
        tasks[t].plan_name != '' &&
        tasks[t].plan_name != undefined &&
        tasks[t].plan_name != null
      ) {
        this.tempPlanNamesArray.push(tasks[t].plan_name);
      }
      if (t == tasks.length - 1) {
        this.tempPlanNamesArray = this.getUnique(this.tempPlanNamesArray);
        for (var p = 0; p < this.tempPlanNamesArray.length; p++) {
          var tempPlan: any = {};
          tempPlan.plan_name = this.tempPlanNamesArray[p];
          tempPlan.planID = this.uuidv4();
          this.planNamesArray.push(tempPlan);
        }
      }
    }
  }
  getUnique(array: any) {
    var uniqueArray = [];
    // Loop through array values
    if (array) {
      for (var i = 0; i < array.length; i++) {
        if (uniqueArray.indexOf(array[i]) === -1) {
          uniqueArray.push(array[i]);
        }
      }
    }
    return uniqueArray;
  }
  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  // to store selected plan name in local storage to generate exucutor report
  selectedPlannameToLS(planname: any) {
    this.plannerName = planname;
    window.localStorage.setItem('selectedPlanname', this.plannerName);
  }
  // function is used for level filter
  addToLevelFilter(id: any, isChecked: any) {
    if (isChecked) {
      this.levelSelected.push(id);
    } else {
      var isPresent = this.levelSelected.findIndex((a: any) => a == id);
      if (isPresent > -1) {
        this.levelSelected.splice(isPresent, 1);
      }
    }
    this.scenarioAddReset();
    // console.log('Level', this.levelSelected);
  }
  // function is used for attr filter
  addToAttributeFilter(id: any, isChecked: any) {
    // console.log(id,isChecked);
    if (isChecked) {
      this.attributeSelected.push(id);
    } else {
      var isPresent = this.attributeSelected.findIndex((a: any) => a == id);
      if (isPresent > -1) {
        this.attributeSelected.splice(isPresent, 1);
      }
    }
    this.scenarioAddReset();
    //  console.log('Attr', this.attributeSelected);
  }

  isCheckedAttr(attribute: any) {
    if (this.attributeSelected.length > 0) {
      var a = this.attributeSelected.findIndex((a: any) => a == attribute);
      return a > -1 ? true : false;
    } else {
      return false;
    }
  }
  resetExRowColorOnFilter() {
    this.newscenariodesc = '';
  }
  // function is used for attr filter
  isPresentInACollection(attribute: any) {
    var isPresent = this.attributeSelected.findIndex(
      (a: any) => a == attribute
    );
    if (isPresent > -1) {
      return true;
    } else return false;
  }

  // function is used for persona filter
  addToPersonaFilter(id: any, isChecked: any) {
    if (isChecked) {
      this.personaSelected.push(id);
    } else {
      var isPresent = this.personaSelected.findIndex(
        (persona: any) => persona == id
      );
      if (isPresent > -1) {
        this.personaSelected.splice(isPresent, 1);
      }
    }
    this.scenarioAddReset();
  }

  // function is used for persona filter
  isPresentInPCollection(persona: any) {
    var isPresent = this.personaSelected.some((r: any) => persona.includes(r));
    if (isPresent) {
      return true;
    } else return false;
  }

  // function is used for priority & cr filter
  addToCrFilter(cr: any, isChecked: any) {
    if (isChecked) {
      this.crSelected.push(cr);
    } else {
      var isPresent = this.crSelected.findIndex((value: any) => value == cr);
      if (isPresent > -1) {
        this.crSelected.splice(isPresent, 1);
      }
    }
    this.scenarioAddReset();
  }
  terminateVideo() {
    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, (iframe) => {
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'stopVideo',
        }),
        '*'
      );
    });
  }
  // function is used for priority & cr filter
  isPresentInCrCollection(scen: any) {
    var prioStr = '';
    if (scen.cr == '+') {
      prioStr = '+' + scen.priority;
    } else {
      prioStr = '-' + scen.priority;
    }
    var isPresent = this.crSelected.findIndex((p: any) => p === prioStr);
    if (isPresent > -1) {
      return true;
    } else {
      return false;
    }
  }

  loadBugList() {
    // this.jiraBugsListComponent.loadData();
    // window.open('/jirabugslist', '_blank');
  }

  createJiraBug() {
    // console.log('createJiraBug called', this.modelData);
    this.jiraBugDetails.project.key = this.modelData.jiraProjectDetails.key;
    // console.log('jiraBugDetails', this.jiraBugDetails);
    // console.log('this.loginDetails', this.loginDetails);
    if (this.modelData.jiraProjectDetails.url) {
      let userdet = this.loginDetails.jiraDetails.find(
        (det: any) => det.url == this.modelData.jiraProjectDetails.url
      );
      // console.log('userdet', userdet);
      let authorizationData = 'Basic ' + btoa(userdet.email + ':' + userdet.token);
      // let authorizationData = 'Basic c3JlZXNhaWxhbS5hdmluYXNoNDg5QGdtYWlsLmNvbTpNM3JPcGprUDI5UnhhbkRpNlkwUUZGM0Y='
      // this.JiraUserService
      //   .jiraBugCreation(authorizationData, userdet.url, this.jiraBugDetails)
      //   .subscribe((response: any) => {
      //     console.log('jiraBugCreation response', response);
      //   });
    } else {
      // console.log('No jira project linked!');
    }
  }
  generateMindMap(){
    this.mainComponent.sendJson(this.selectedEntity);
  }
}
